import React from 'react';
import './styles/scope.scss';
import { ShakeProvider } from './ShakeProvider';
import ShakeEntrypoint from './components/ShakeEntrypoint';
import ShakeModal from './components/ShakeModal';

export default function ShakeFeature(props) {
  return (
    <div className="shakeScope">
      <ShakeProvider {...props}>
        <ShakeEntrypoint />
        <ShakeModal />
      </ShakeProvider>
    </div>
  );
}
